import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getStatesList = async ({ commit }) => {
  commit('setStateIsLoading', true);
  let url = `/states/selectable`;

  await connection.get(url)
    .then(res => {
      const states = res.data.data;
      commit('setStatesSelectable', states);
      commit('setStateIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStateIsLoading', false);
    });
}

export const getStatesByCountry = async ({ commit }, countryId) => {
  commit('setStateIsLoading', true);
  let url = `/states/selectable/${countryId}`;

  await connection.get(url)
    .then(res => {
      const states = res.data.data;
      commit('setStatesSelectable', states);
      commit('setStateIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStateIsLoading', false);
    });
}

export const loadStates = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setStateIsLoading', true);
    let url = `/states`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const states = res.data.data;
        commit('setStates', states);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setStatesPaginated', res.data);
        commit('setStateIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setStateIsLoading', false);
      });
}

export const stateById = async ({ commit }, id) => {
  commit('setStateIsLoading', true);
  await connection.get(`/states/${id}`)
    .then(res => {
      commit('setStateDetail', res.data.data);
      commit('setStateIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStateIsLoading', false);
    });
}

export const storeState = async ({ commit }, state) => {
  commit('setStateIsCreating', true);
  await connection.post(`/states/create`, state)
    .then(res => {
      commit('saveNewStates', res.data);
      commit('setStateIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStateIsCreating', false);
    });
}

export const updateState = async ({ commit }, state ) => {
  commit('setStateIsUpdating', true);
  await connection.put(`/states/${state.id}/update`, state)
    .then(res => {
      commit('saveUpdatedState', res.data);
      commit('setStateIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStateIsUpdating', false);
    });
}

export const deleteState = async ({ commit }, state) => {
  commit('setStateIsDeleting', true);
  await connection.delete(`/states/${state.id}/delete`)
    .then(res => {
      commit('setDeleteState', res.data);
      commit('setStateIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStateIsDeleting', false);
    });
}
